import {SubmitButton} from "components/Button";
import {FormCard} from "components/Form";
import {DashboardLayout} from "components/Layout";
import {CircleLoader} from "components/Loader";
import {useDetailHospital} from "hooks/SuperAdmin/Hospital";
import QRCodeStyling from "qr-code-styling";
import {useEffect, useRef} from "react";
import {useHistory, useParams} from "react-router-dom";
import {loadLocalAssets} from "utils/loader";

export function MasterRumahSakitDetailPage() {
	const history = useHistory();
	const params = useParams();
	const {id} = params;

	const {data: detailHospital, isLoading: loadingFetcing} = useDetailHospital(id);

	const qrRef = useRef(null);
	const qrCode = useRef(null);

	useEffect(() => {
		if (detailHospital?.data?.id) {
			if (!qrCode.current) {
				qrCode.current = new QRCodeStyling({
					width: 120,
					height: 120,
					data: String(detailHospital.data.id),
					margin: 0,
					type: "svg",
					qrOptions: {typeNumber: "0", mode: "Byte", errorCorrectionLevel: "Q"},
					imageOptions: {saveAsBlob: true, hideBackgroundDots: false, imageSize: 0.4, margin: 0},
					dotsOptions: {type: "extra-rounded", color: "#529da1", roundSize: true},
					backgroundOptions: {round: 0, color: "#ffffff"},
					image: null,
					dotsOptionsHelper: {
						colorType: {single: true, gradient: false},
						gradient: {linear: true, radial: false, color1: "#6a1a4c", color2: "#6a1a4c", rotation: "0"},
					},
					cornersSquareOptions: {type: "extra-rounded", color: "#f36e21"},
					cornersSquareOptionsHelper: {
						colorType: {single: true, gradient: false},
						gradient: {linear: true, radial: false, color1: "#000000", color2: "#000000", rotation: "0"},
					},
					cornersDotOptions: {type: "", color: "#000000"},
					cornersDotOptionsHelper: {
						colorType: {single: true, gradient: false},
						gradient: {linear: true, radial: false, color1: "#000000", color2: "#000000", rotation: "0"},
					},
					backgroundOptionsHelper: {
						colorType: {single: true, gradient: false},
						gradient: {linear: true, radial: false, color1: "#ffffff", color2: "#ffffff", rotation: "0"},
					},
				});
			} else {
				qrCode.current.update({data: String(detailHospital.data.id)});
			}

			if (qrRef.current) {
				qrRef.current.innerHTML = "";
				qrCode.current.append(qrRef.current);
			}
		}
	}, [detailHospital?.data?.id]);

	const handleDownloadQR = () => {
		const hospitalId = detailHospital?.data?.id;

		if (!hospitalId || !qrCode.current) return;
		qrCode.current.download({name: `qr-hospital-${hospitalId}`, extension: "png"});
	};

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar List Rumah Sakit" title="Edit Data Rumah Sakit">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar List Rumah Sakit"
				title={`Detail Data ${detailHospital?.data?.name}`}
				onBackButtonClick={() => history.push("/master-rumah-sakit")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-12 col-lg-6">
						<div class="setting-item">
							<label class="setting-label ">Logo</label>
							<div class="change-img mb-4">
								<div class="for-img-change">
									<div class="bx-img-change">
										<img
											alt="Logo Rumah Sakit"
											class="img-fluid"
											src={
												detailHospital?.data?.logo
													? detailHospital?.data?.logo
													: loadLocalAssets("img/user-default.jpg")
											}
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Nama Rumah Sakit</label>
							<p className="text-bold text-grey">{detailHospital?.data?.name}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Alamat</label>
							<p className="text-bold text-grey">{detailHospital?.data?.address}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Alama Pengiriman</label>
							<p className="text-bold text-grey">{detailHospital?.data?.shippingAddress}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Nomor Telepon</label>
							<p className="text-bold text-grey">{detailHospital?.data?.phone}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Email</label>
							<p className="text-bold text-grey">{detailHospital?.data?.email}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Fax</label>
							<p className="text-bold text-grey">{detailHospital?.data?.fax}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">NPWP</label>
							<p className="text-bold text-grey">{detailHospital?.data?.npw}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">Website</label>
							<p className="text-bold text-grey">
								<a href={detailHospital?.data?.website} rel="noreferrer" target="_blank">
									{detailHospital?.data?.website}
								</a>
							</p>
						</div>
					</div>

					<div class="col-sm-12 col-lg-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Bank</label>
							<p className="text-bold text-grey">{detailHospital?.data?.bankProvider}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">No Rekening Bank</label>
							<p className="text-bold text-grey">{detailHospital?.data?.bankAccountNumber}</p>
						</div>
						<div class="setting-item">
							<label class="setting-label ">A.N Bank</label>
							<p className="text-bold text-grey">{detailHospital?.data?.bankAccountHolder}</p>
						</div>
						{detailHospital?.data?.id && (
							<div class="setting-item">
								<label class="setting-label">QR Code Rumah Sakit</label>
								<div className="d-flex align-items-center gap-3 mt-2">
									<div ref={qrRef} id="qr-hospital" />
									<button
										className="btn btn-outline-secondary"
										type="button"
										onClick={handleDownloadQR}>
										Download QR
									</button>
								</div>
							</div>
						)}
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/master-rumah-sakit/edit/${id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
